import { Injectable } from '@angular/core';
import { AuthService, FeatureFlagManagerService, UserService, LfxAnalyticsService } from '@services';
import { forkJoin, Observable, of } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import { UserContext } from '@models';

@Injectable({
  providedIn: 'root',
})
export class InitService {
  constructor(
    public authService: AuthService,
    private featureFlagManagerService: FeatureFlagManagerService,
    private userService: UserService,
    private analyticsService: LfxAnalyticsService
  ) {}

  init() {
    // Initialize analytics service early
    this.analyticsService.trackEvent('Application Initialized', {
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent
    }).catch(error => {
      console.error('Failed to track application initialization:', error);
    });

    return this.authService.isAuthenticated$
      .pipe(
        switchMap(res => {
          if (!res) {
            return of(false);
          }

          return this.initUser();
        })
      )
      .toPromise();
  }

  initUser(): Observable<[any, any, unknown, UserContext[]]> {
    return this.authService.initializeUserProfile().pipe(
      switchMap(() =>
        forkJoin([
          this.authService.setPermissions(),
          this.authService.setRoles(),
          this.authService.userProfile$.pipe(
            first(),
            switchMap(userProfile =>
              this.featureFlagManagerService.initialize(userProfile)
            )
          ),
          this.userService.getUserContexts(),
        ])
      )
    );
  }
}
